import Vue from "vue";
import { ProductPriceStock, WarehouseStock } from "@/model/product-price-stock";
import { Config } from "@/model/config";
import { translate } from "@/filters";
import { Util } from "@/util/util";
export interface PpsMixinData {
  productBrand: string;
  productBusinessUnit: string;
  pps: ProductPriceStock;
  config: Config;
  stockAvailabilityStatus: string;
}

export const ppsMixin = Vue.extend({
  computed: {
    config() {
      return Util.getConfig();
    },
    textColor(): string {
      switch (this.stockAvailabilityStatus) {
        case 'unavailable':
          return '#bababa';
        case 'sparse':
          return '#F8974D';
        case 'available':
          return '#1AA62B';
        default:
          return '#bababa';
      }
    },
    isTruck(): boolean {
      const vm = (this as unknown) as Vue & PpsMixinData;
      if (vm.productBusinessUnit) {
        const vm = (this as unknown) as Vue & PpsMixinData;
        return vm.productBusinessUnit.toLowerCase() === "truck";
      } else if (vm.pps.productInfo) {
        return vm.pps.productInfo.businessUnit.toLowerCase() === "truck";
      }
      return false;
    },
    isAgricultural(): boolean {
      const vm = (this as unknown) as Vue & PpsMixinData;
      if (vm.productBusinessUnit) {
        return vm.productBusinessUnit.toLowerCase() === "agricultural";
      } else if (vm.pps.productInfo) {
        return vm.pps.productInfo.businessUnit.toLowerCase() === "agricultural";
      }
      return false;
    },
    isOTR(): boolean {
      const vm = (this as unknown) as Vue & PpsMixinData;
      if (vm.productBusinessUnit) {
        return vm.productBusinessUnit.toLowerCase() === "otr";
      } else if (vm.pps.productInfo) {
        return vm.pps.productInfo.businessUnit.toLowerCase() === "otr";
      }
      return false;
    },
    isMRLBrand(): boolean {
      const vm = (this as unknown) as Vue & PpsMixinData;
      if (vm.productBrand) {
        return vm.productBrand.toLowerCase() === "mrl";
      } else if (vm.pps.productInfo) {
        return vm.pps.productInfo.brand.toLowerCase() === "mrl";
      }
      return false;
    },
    stockAvailabilityStatus(): string {
      const vm = (this as unknown) as Vue & PpsMixinData;

      if (vm.pps) {
        if (vm.pps.totalStockAvailable > 0) {
          if (vm.pps.totalStockAvailable >= 24) {
            return "available";
          } else if (this.isAgricultural && this.isMRLBrand) {
            return vm.pps.totalStockAvailable >= 10 ? "available" : "sparse";
          } else if (this.isAgricultural || this.isOTR) {
            return vm.pps.totalStockAvailable >= 4 ? "available" : "sparse";
          }
          return "sparse";
        } else if (vm.pps.totalStock > 0) {
          return 'sparse'
        }
      }
      return "unavailable";
    },
    warehouseStocks(): WarehouseStock[] {
      const vm = (this as unknown) as Vue & PpsMixinData;

      if (vm.pps) {
        return vm.pps.stocks;
      }
      return [];
    },
    hasStockDeliveries(): boolean {
      for (const s of this.warehouseStocks) {
        if (s.deliveries !== undefined && s.deliveries.length > 0) {
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    getSrcForWarehouse(country: string): string {
      const vm = (this as unknown) as Vue & PpsMixinData;

      return `${
        vm.config.resourcePath
      }/dist/img/warehouse-flag/${country.toUpperCase()}.svg`;
    },
    /**
     * Gets the translated delivery time based on the delivery estimate calculated through the method below
     * {@see getDeliveryEstimateForCustomerAndWarehouse}
     */
    getDeliveryEstimateForCustomerAndWarehouseAsString(
      warehouse: string
    ): string {
      const deliveryEstimate = this.getDeliveryEstimateForCustomerAndWarehouse(
        warehouse
      );
      if (deliveryEstimate.min < 0 && deliveryEstimate.max < 0) {
        return translate("product.specs.deliveryTimeUponRequest");
      }

      return translate(
        "product.specs.deliveryTimeDescription",
        `${deliveryEstimate.min.toString(10)}-${deliveryEstimate.max.toString(
          10
        )}`
      );
    },
    /**
     * Method which returns the estimated delivery time for the given warehouse.
     * This is based on the country of the currently logged in customer.
     */
    getDeliveryEstimateForCustomerAndWarehouse(
      warehouse: string
    ): { min: number; max: number } {
      const vm = (this as unknown) as Vue & PpsMixinData;

      const found = vm.config.deliveryEstimateForWarehouse.find(item => {
        return (
          item.warehouse.toLowerCase() ===
          `${vm.config.customerCountry.toLowerCase()}_${warehouse.toLowerCase()}`
        );
      });

      return {
        min: found && found.min ? found.min : -1,
        max: found && found.max ? found.max : -1
      };
    },
    toLocalDate(value: string): string {
      try {
        const date = new Date(value);
        return date.toLocaleDateString(
          "nl-NL", // this.config.locale ???
          { day: "2-digit", month: "2-digit", year: "numeric" }
        );
      } catch (e) {
        return value;
      }
    }
  }
});
